import { isFrameInSite } from './nuiFrameLib';
import {htmlA} from './nuiHtmlBasics';

export function parseUrl() {
  let url = window.location.href;
  const re = new RegExp(
    "\/nui\/"+
      "(loginRobotax|loginFinParser|userDataForm|renewPassword|taxform|payment)"+
      "(?:\/)?(russia|spain)?\/(ru|ua|en|es)");
  const parts = re.exec(url);
  return {
    "residenceCountry": (parts != undefined && parts.length >= 3)
      ? parts[2]
      : "none",
    "language": (parts != undefined && parts.length >= 4)
      ? parts[3]
      : "none"
  };
}

export const language = parseUrl().language;
export const residenceCountry = parseUrl().residenceCountry;

export default function text(translationsMap) {
  let result = translationsMap[language];
  if (result == undefined) {
    return translationsMap['en'];
  } else {
    return translationsMap[language];
  }
}

export function getCoreDomain() {
  return window.location.hostname
    .replace('app.', '')
    .replace('dev.', '')
    .replace('es.', '');
}

// ISO alpha2 of the tax jurisdiction the register/login form is served under,
// derived from the host subdomain (the WP site it is embedded on). NOTE: the UI
// `language` (es/en/ru/ua) is NOT the jurisdiction - a Spanish resident may use the
// en/ru UI - so we key off the host, not language.
//   finparser*        -> RU   (single jurisdiction)
//   es.robotaxmaker*  -> ES
//   cz.robotaxmaker*  -> CZ
//   robotaxmaker*     -> ''   (general portal, jurisdiction not chosen yet)
export function jurisdictionAlpha2() {
  const host = window.location.hostname.replace('app.', '').replace('dev.', '');
  if (host.includes('finparser')) return 'RU';
  if (host.startsWith('es.'))     return 'ES';
  if (host.startsWith('cz.'))     return 'CZ';
  return '';
}

const siteMap = {
  home: "",
  singUp: "sing-up",
  account: "account",
  taxForm: "tax-form",
  payment: "payment",
};

function notDefaultLanguage() {
  if (language === 'es') {
    return '';
  } else {
    return `${language}/`;
  }
}

export function supportEmail() {
  return (getCoreDomain() == 'finparser.com')
    ? htmlA({link: "mailto:support@finparser.com",
             text: "support@finparser.com"})
    : htmlA({link: "mailto:support@robotaxmaker.com",
             text: "support@robotaxmaker.com"});
}

export function homeUrl() {
  return `${location.protocol}//${window.location.hostname}`;
}

export function singUpUrl(service = 'robotaxmaker.com') {
  return isFrameInSite()
    ? (`${location.protocol}//${window.location.hostname}/` +
       `${notDefaultLanguage()}${siteMap.singUp}`)
    : (service == 'finparser.com' || getCoreDomain() == 'finparser.com'
       ? '/nui/loginFinParser/' + language
       : '/nui/loginRobotax/' + language);
}

export function taxFormUrl(service = 'robotaxmaker.com') {
  return isFrameInSite()
    ? (`${location.protocol}//${window.location.hostname}/` +
       `${notDefaultLanguage()}${siteMap.taxForm}`)
    : (service == 'finparser.com' || getCoreDomain() == 'finparser.com'
       ? '/nui/taxform/russia/' + language
       : '/nui/taxform/spain/' + language);
}

export function paymentUrl() {
  return isFrameInSite()
    ? (`${location.protocol}//${window.location.hostname}/` +
       `${notDefaultLanguage()}${siteMap.payment}`)
    : (getCoreDomain() == 'finparser.com'
       ? '/nui/payment/russia/' + language
       : '/nui/payment/spain/' + language);
}
